<template>
  <div class="person-header">
    <div class="examinePopList fnt_18">
      <div class="exaitem" v-for="item in teamMemberList" :key="item.fieldSort">
        <span class="c-gray">{{ item.fieldName }}：</span>
        <span v-if="item.fieldType === 'text'">{{ item.newValue }}</span>
        <span v-else>{{ getDisplayText(item) }}</span>
      </div>
      <br>
    </div>
  </div>
</template>
<script>

import { queryByParentId } from '@/api/saiti'
import { getCompetitionDict } from '@/api/api'

export default {
  name: 'TeamMemberInfo',
  props: {
    userInfoArray: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      allList: [], // 全部字段信息
      dictCodeArray: [], // 字典值数组
      showList: [], // 展示字段信息
      teamMemberList: [], // 队员字段信息
      provinceList: [] // 省列表
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      console.log(this.userInfoArray, 'this.userInfoArray')
      const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + this.userInfoArray.templateId
      queryByParentId(paTemp).then(res => {
        if (res.success) {
          // 全部字段信息
          this.allList = JSON.parse(res.result.fieldJson)
          // 获取所有字典值
          this.allList.forEach(item => {
            // 检查 item 中是否有 dictCode 属性
            if (item.dictCode) {
              // 将 dictCode 数据添加到数组中
              this.dictCodeArray.push(item.dictCode)
            }
          })
          this.findDictCode()
        }
      })
    },

    // 给字段值绑定字典列表
    // findDictCode() {
    //   const param = 'dictCode=' + this.dictCodeArray.join(',')
    //   getCompetitionDict(param).then(res => {
    //     if (res.success) {
    //       const dictCodeList = res.result
    //       this.allList = this.allList.map(showItem => {
    //         const dictItem = dictCodeList.find(dictItem => dictItem.dictCode === showItem.dictCode)
    //         if (dictItem) {
    //           showItem.list = dictItem.list
    //         }
    //         if (showItem.fieldType === 'upload') {
    //           showItem.fileList = []
    //         }
    //         if (showItem.fieldCode === 'countryCode') {
    //           showItem.fieldType = 'text'
    //           showItem.newValue = this.userInfoArray.countryName
    //         }
    //         if (showItem.fieldCode === 'cityCode') {
    //           showItem.fieldType = 'text'
    //           showItem.newValue = this.userInfoArray.cityName
    //         }
    //         return showItem
    //       })
    //       this.showList = this.allList.filter(item => item.isTeam === 0)
    //       const teamMemberListCopy = JSON.parse(JSON.stringify(this.showList))
    //       teamMemberListCopy.forEach(item => {
    //         if (item.fieldCode === 'leaderName') {
    //           item.fieldName = this.globalDataArray.siteTemplateLanguage.team_member_name
    //           item.fieldCode = 'userName'
    //         }
    //       })
    //       this.teamMemberList = teamMemberListCopy
    //       console.log(this.teamMemberList, 'this.teamMemberList')
    //       this.teamMemberList.forEach(item => {
    //         if (item.fieldCode !== 'countryCode' && item.fieldCode !== 'cityCode') {
    //           item.newValue = this.userInfoArray[item.fieldCode]
    //         }
    //         if (item.fieldCode === 'company') {
    //           if (item.newValue) {
    //             item.isShow = '1'
    //           }
    //         }
    //         // if (item.newValue === '02' && item.fieldCode === 'jobType') {
    //         //   // this.teamMemberList.forEach(item => {
    //         //   //   if (item.fieldCode === 'onlineCode') {
    //         //   //     item.isShow = '1'
    //         //   //   }
    //         //   //   if (item.fieldCode === 'educational') {
    //         //   //     item.isShow = '1'
    //         //   //   }
    //         //   //   if (item.fieldCode === 'studentUrl') {
    //         //   //     item.isShow = '1'
    //         //   //   }
    //         //   // })
    //         // }
    //       })
    //
    //       // 新增：获取单位类型和职业类型的字典数据
    //       const companyTypeDict = dictCodeList.find(d => d.dictCode === 'competition_signup_company_type')
    //       const jobTypeDict = dictCodeList.find(d => d.dictCode === 'competition_signup_job_type')
    //
    //       // 新增：判断是否为高校和学生
    //       const isUniversity = this.userInfoArray.companyType === '02'
    //       const isStudent = this.userInfoArray.jobType === '02'
    //
    //       // 新增：只有当单位类型是高校且职业类型是学生时才显示特定字段
    //       if (isUniversity && isStudent) {
    //         this.teamMemberList.forEach(item => {
    //           if (item.fieldCode === 'onlineCode' || item.fieldCode === 'educational' || item.fieldCode === 'studentUrl') {
    //             item.isShow = '1'
    //           }
    //         })
    //       }
    //
    //       this.teamMemberList = this.teamMemberList.filter(item => item.isShow === '1')
    //     }
    //   })
    // },

    // 截取原代码中需要修改的部分
    findDictCode() {
      const param = 'dictCode=' + this.dictCodeArray.join(',')
      getCompetitionDict(param).then(res => {
        if (res.success) {
          const dictCodeList = res.result
          this.allList = this.allList.map(showItem => {
            const dictItem = dictCodeList.find(dictItem => dictItem.dictCode === showItem.dictCode)
            if (dictItem) {
              showItem.list = dictItem.list
            }
            if (showItem.fieldType === 'upload') {
              showItem.fileList = []
            }
            if (showItem.fieldCode === 'countryCode') {
              showItem.fieldType = 'text'
              showItem.newValue = this.userInfoArray.countryName
            }
            if (showItem.fieldCode === 'cityCode') {
              showItem.fieldType = 'text'
              showItem.newValue = this.userInfoArray.cityName
            }
            return showItem
          })
          this.showList = this.allList.filter(item => item.isTeam === 0)
          const teamMemberListCopy = JSON.parse(JSON.stringify(this.showList))
          teamMemberListCopy.forEach(item => {
            if (item.fieldCode === 'leaderName') {
              item.fieldName = this.globalDataArray.siteTemplateLanguage.team_member_name
              item.fieldCode = 'userName'
            }
          })
          this.teamMemberList = teamMemberListCopy
          console.log(this.teamMemberList, 'this.teamMemberList')
          this.teamMemberList.forEach(item => {
            if (item.fieldCode !== 'countryCode' && item.fieldCode !== 'cityCode') {
              item.newValue = this.userInfoArray[item.fieldCode]
            }
            if (item.fieldCode === 'company') {
              if (item.newValue) {
                item.isShow = '1'
              }
            }
          })

          // 新增：获取单位类型和职业类型的字典数据
          const companyTypeDict = dictCodeList.find(d => d.dictCode === 'competition_signup_company_type')
          const jobTypeDict = dictCodeList.find(d => d.dictCode === 'competition_signup_job_type')

          // 新增：判断是否为高校和学生
          const isUniversity = this.userInfoArray.companyType === '02'
          const isStudent = this.userInfoArray.jobType === '02'

          // 新增：只有当单位类型是高校且职业类型是学生时才显示特定字段
          if (isUniversity && isStudent) {
            this.teamMemberList.forEach(item => {
              if (item.fieldCode === 'onlineCode' || item.fieldCode === 'educational' || item.fieldCode === 'studentUrl') {
                item.isShow = '1'
              }
            })
          }

          this.teamMemberList = this.teamMemberList.filter(item => item.isShow === '1')
        }
      })
    },

    getDisplayText(item) {
      if (item.list && item.list.length > 0) {
        const foundItem = item.list.find(listItem => listItem.itemValue === item.newValue)
        return foundItem ? foundItem.itemText : ''
      }
      if (item.newValue) {
        const filename = item.newValue.split('/').pop() // 移除开头的 file/
        return filename.replace(/_(\d+)(\.pdf)$/, '$2') // $2 对应第二个捕获组 (.pdf)
      }
      return ''
    }
  }
}
</script>
